import uniqBy from 'lodash/uniqBy';
import { message } from '@whalecloud/fdx';
import { i18n } from 'fishx';
import { grantDefaultRole } from '@/services/api';
import {
  queryPortals,
  queryEnabled,
  queryUsers,
  queryUsersHistory,
  queryUsersComponent,
  queryComponentsByMenu,
  editUser,
  resetPwd,
  lockUser,
  unLockUser,
  disableUser,
  enableUser,
  changeUserMenu,
  setFavorites,
  queryUserFavouritMenu,
  queryAllUsers,
  checkUserCode,
} from '@pages/UserMgr/services/user';
import { queryRoles, queryUserRoles, changeUserRoles } from '@pages/UserMgr/services/role';
import {
  queryRolePortals,
  queryPortalsByUser,
  queryUserPortals,
  changeUserPortals,
  queryPortalsDirMenu,
  queryMenusByPortal,
} from '@pages/UserMgr/services/portal';
import { qryMenuListByUser, qryMenuListByUserParty, qryMenuListByDirId } from '@pages/UserMgr/services/menu';
import { qryDirsByParty, qryDirsByDir } from '@pages/UserMgr/services/dir';
import { qryPorletByUser, qryPorletByPortal, qryType, qryPorletByType } from '@pages/UserMgr/services/portlet';

const COMMON_FILTER_HISTORY = {
  pageIndex: 0,
  pageLen: 10,
};

const formatter = (data, parentId = null, parentType = null) => {
  if (data.length <= 0) return [];
  return data
    .map(item => {
      const result = {
        ...item,
        partyId: item.partyId ? item.partyId : 0,
        key: item.seq ? `${item.portalId}_${item.seq}` : item.portalId.toString(),
        title: item.partyName ? item.partyName : item.portalName,
      };
      if (parseInt(item.type, 10) === 0) result.children = [];
      else result.isLeaf = true;
      if (parentId) {
        result.parentId = parentId;
        result.parentType = parentType;
      }
      return result;
    })
    .filter(item => item);
};

// 数组转树型结构
const arrayToTree = (array, id = 'partyId', pId = 'parentId', children = 'children') => {
  const data = JSON.parse(JSON.stringify(array));
  const hash = {};
  const result = [];
  data.forEach((item, index) => {
    const itemN = item;
    if (itemN.parentId) {
      hash[data[index][id]] = data[index];
    } else {
      itemN.children = [];
      result.push(itemN);
    }
  });

  data.forEach(item => {
    if (item[pId]) {
      const hashVP = hash[item[pId]];
      const { parentType, partyId } = item;
      if ((hashVP && parentType === 'portalId' && partyId === 0) || (hashVP && parentType !== 'portalId' && partyId !== 0)) {
        if (!hashVP[children]) {
          hashVP[children] = [];
        }
        hashVP[children].push(item);
      }
    }
  });

  result.forEach(item => {
    Object.keys(hash).forEach(key => {
      const { parentType } = hash[key];
      if (item[parentType] === hash[key][parentType]) {
        item.children.push(hash[key]);
      }
    });
  });
  return result;
};

let initialPageConfig = {};

export default {
  namespace: 'userMgr',

  state: {
    emailRequired: false, // email是否必填
    portalList: [], // portal查询条件
    list: [],
    pagination: {},
    filterParam: {
      state: 'A',
    },
    arrayList: [], // 弹出层数组
    upList: [],
    downList: [],
    // grantMenu
    menuTree: [],
    portalMenuList: [],
    historyData: {
      list: [],
      pagination: {},
    },
    roleList: [], // 角色列表
  },

  effects: {
    *queryPortals(_, { call, put }) {
      const { success, data } = yield call(queryPortals);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            portalList: data,
          },
        });
      }
    },
    *queryEmailRequire(_, { call, put }) {
      const { success, data } = yield call(queryEnabled);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            emailRequired: JSON.parse(data),
          },
        });
      }
    },
    *fetch({ payload = COMMON_FILTER_HISTORY }, { call, put }) {
      const param = {};
      Object.keys(payload).forEach(key => {
        const val = payload[key];
        if (val === 0) {
          param[key] = val;
        } else if (val) {
          param[key] = val;
        }
      });
      const { success, data } = yield call(queryUsers, param);
      if (success) {
        const { list, pageSize, total, pageNum, pages } = data;
        list.map(v => {
          Object.assign(v, { key: `userMgrList_${v.userId}` });
          return v;
        });
        initialPageConfig = {
          total,
          lastPage: pages,
        };
        yield put({
          type: 'save',
          payload: {
            list,
            pagination: {
              current: pageNum,
              pageSize,
              total,
            },
            filterParam: {
              ...param,
            },
          },
        });
      } else {
        yield put({
          type: 'clearData',
        });
      }
    },
    *queryAllRoles(_, { call, put }) {
      const { success, data } = yield call(queryRoles);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            roleList: data,
          },
        });
      }
    },
    *queryUsersHistory({ payload }, { call, put }) {
      const { success, data } = yield call(queryUsersHistory, payload);
      if (success) {
        const { list, pageSize, total, pageNum } = data;
        list.map(v => {
          Object.assign(v, { key: `userHistory_${v.recId}_${v.userName}` });
          return v;
        });
        yield put({
          type: 'save',
          payload: {
            historyData: {
              list,
              pagination: {
                current: pageNum,
                pageSize,
                total,
              },
            },
          },
        });
      }
    },
    *queryRoles({ payload }, { call, put }) {
      const { success, data } = yield call(queryRoles);
      if (success) {
        yield put({
          type: 'saveDifference',
          payload: {
            upList: data,
            keyProp: 'roleId',
            ...payload,
          },
        });
      }
    },
    *queryUserRoles({ payload }, { call, put }) {
      const { userId } = payload;
      const { success, data } = yield call(queryUserRoles, userId);
      if (success) {
        yield put({
          type: 'queryRoles',
          payload: {
            downList: data,
          },
        });
      }
    },
    *changeUserRoles({ payload }, { call, put }) {
      const { userId, param, method } = payload;
      const { success, data } = yield call(changeUserRoles, userId, param, method);
      if (success && data === 'success') {
        message.success(
          i18n(method === 'POST' ? 'USERMGR_GRANT_ROLE_SUCCESS' : 'USERMGR_DEGRANT_ROLE_SUCCESS')
        );
        yield put({
          type: 'queryUserRoles',
          payload: {
            userId,
          },
        });
      }
    },
    *editUser({ payload }, { call, put, select }) {
      const { method, roles = [], ...otherProps } = payload;
      const { success, data } = yield call(editUser, otherProps, method);
      if (success) {
        message.success(
          i18n(method === 'PUT' ? 'USERMGR_MOD_USER_SUCCESS' : 'USERMGR_ADD_USER_SUCCESS')
        );
        const { filterParam, pagination } = yield select(state => state.userMgr);
        let filter = {
          ...filterParam,
        };
        if (method === 'POST') {
          if (roles.length > 0) {
            // 授权默认角色
            yield put({
              type: 'grantDefaultRole',
              payload: {
                userId: data.userId,
                roleIdList: roles,
              },
            });
          }
          // 新增用户跳转至最后一页
          const { pageSize } = pagination;
          const { total, lastPage } = initialPageConfig;
          if (total >= pageSize * lastPage) {
            filter.pageIndex = lastPage;
          } else {
            filter.pageIndex = lastPage - 1;
          }
        } else filter = filterParam;
        yield put({
          type: 'fetch',
          payload: {
            ...filter,
          },
        });
      }
    },
    *grantDefaultRole({ payload }, { call }) {
      const { userId, roleIdList } = payload;
      yield call(grantDefaultRole, userId, roleIdList);
    },
    *resetPwd({ payload }, { call }) {
      const { userId } = payload;
      const { success, data } = yield call(resetPwd, userId);
      if (success && data === 'success') {
        message.success(i18n('USERMGR_RESET_PASSWD_SUCCESS'));
      }
    },
    *lockUser({ payload }, { call, put, select }) {
      const { userId } = payload;
      const { success, data } = yield call(lockUser, userId);
      if (success && data === 'success') {
        message.success(i18n('USERMGR_LOCK_USER_SUCCESS'));
        const { filterParam } = yield select(state => state.userMgr);
        yield put({
          type: 'fetch',
          payload: {
            ...filterParam,
          },
        });
      }
    },
    *unLockUser({ payload }, { call, put, select }) {
      const { userId } = payload;
      const { success, data } = yield call(unLockUser, userId);
      if (success && data === 'success') {
        message.success(i18n('USERMGR_UNLOCK_USER_SUCCESS'));
        const { filterParam } = yield select(state => state.userMgr);
        yield put({
          type: 'fetch',
          payload: {
            ...filterParam,
          },
        });
      }
    },
    *disableUser({ payload }, { call, put, select }) {
      const { userId } = payload;
      const { success, data } = yield call(disableUser, userId);
      if (success && data === 'success') {
        message.success(i18n('USERMGR_DISABLE_USER_SUCCESS'));
        const { filterParam } = yield select(state => state.userMgr);
        yield put({
          type: 'fetch',
          payload: {
            ...filterParam,
          },
        });
      }
    },
    *enableUser({ payload }, { call, put, select }) {
      const { userId } = payload;
      const { success, data } = yield call(enableUser, userId);
      if (success && data === 'success') {
        message.success(i18n('USERMGR_ENABLE_USER_SUCCESS'));
        const { filterParam } = yield select(state => state.userMgr);
        yield put({
          type: 'fetch',
          payload: {
            ...filterParam,
          },
        });
      }
    },
    // 上层portalList
    *queryRolePortals({ payload }, { call, put, select }) {
      const { userId } = payload;
      const { success, data } = yield call(queryRolePortals, userId);
      if (success) {
        const downList = data.concat(payload.downList);
        const param = yield select(state => state.userMgr);
        yield put({
          type: 'saveDifference',
          payload: {
            upList: param.portalList,
            downList,
            extraDownList: data,
            keyProp: 'portalId',
          },
        });
      }
    },
    // 下层portalList
    *queryUserPortals({ payload }, { call, put }) {
      const { userId } = payload;
      const { success, data } = yield call(queryUserPortals, userId);
      if (success) {
        yield put({
          type: 'queryRolePortals',
          payload: {
            downList: data,
            ...payload,
          },
        });
        if (payload.portalId) {
          yield put({
            type: 'queryMenusByPortal',
            payload: {
              ...payload,
            },
          });
        }
      }
    },
    *queryMenusByPortal({ payload }, { call, put }) {
      const { success, data } = yield call(queryMenusByPortal, payload);
      if (success) {
        yield put({
          type: 'queryUserFavouritMenu',
          payload: {
            portalMenuList: data.filter(v => v.type !== '0'),
            ...payload,
          },
        });
      }
    },
    *queryUserFavouritMenu({ payload }, { call, put }) {
      const { success, data } = yield call(queryUserFavouritMenu, payload);
      if (success) {
        yield put({
          type: 'saveFavourite',
          payload: {
            ...payload,
            portalUserMenuList: data,
          },
        });
      }
    },
    *setFavorites({ payload }, { call }) {
      const { param, method } = payload;
      yield call(setFavorites, param, method);
    },
    // 更改用户portal
    *changeUserPortals({ payload }, { call, put, select }) {
      const { userId, portalId, param } = payload;
      const { success, data } = yield call(changeUserPortals, userId, portalId, param);
      if (success && data === 'success') {
        message.success(i18n('USERMGR_GRANT_PORTAL_SUCCESS'));
        const { filterParam } = yield select(state => state.userMgr);
        yield put({
          type: 'fetch',
          payload: {
            ...filterParam,
          },
        });
      }
    },
    // 上层menuList
    *qryMenuListByUserParty({ payload }, { call, put, select }) {
      const { userId, portalId, partyId, reload = false } = payload;
      const { success, data } = yield call(qryMenuListByUserParty, userId, portalId, partyId);
      if (success) {
        const { downList } = yield select(state => state.userMgr);
        const upList = data;
        if (reload || downList.length <= 0) {
          yield put({
            type: 'qryMenuListByUser',
            payload: {
              upList,
              ...payload,
            },
          });
        } else {
          yield put({
            type: 'saveDifference',
            payload: {
              downList,
              upList,
              keyProp: 'privId',
              keepOn: true, // 保留重复字段
              ...payload,
            },
          });
        }
      }
    },
    // 下层menuList
    *qryMenuListByUser({ payload }, { call, put }) {
      const { userId } = payload;
      const { success, data } = yield call(qryMenuListByUser, userId);
      if (success) {
        yield put({
          type: 'saveDifference',
          payload: {
            downList: data,
            keyProp: 'privId',
            keepOn: true, // 保留重复字段
            ...payload,
          },
        });
      }
    },
    // 获取portal树节点下的dirsList
    *qryDirsByParty({ payload }, { call, put }) {
      const { portalId, partyId } = payload;
      const { success, data } = yield call(qryDirsByParty, portalId, partyId);
      if (success) {
        yield put({
          type: 'saveAppendMenuTree',
          payload: {
            sonList: data,
            record: payload,
          },
        });
      }
    },
    // 获取用户门户列表
    *queryUserPortalsForMenu({ payload }, { call, put }) {
      const { userId } = payload;
      const { success, data } = yield call(queryPortalsByUser, userId);
      if (success) {
        const list = formatter(data);
        if (list.length > 0) {
          const query = {
            ...list[0],
          };
          // 请求第一个节点下的子集dir
          yield put({
            type: 'qryDirsByParty',
            payload: {
              arrayList: list,
              ...query,
            },
          });
          // 请求第一个节点的菜单menu
          yield put({
            type: 'qryMenuListByUserParty',
            payload: {
              ...query,
              ...payload,
            },
          });
        } else {
          // 请求下层menu tableList
          yield put({
            type: 'qryMenuListByUser',
            payload: {
              upList: [],
              ...payload,
            },
          });
        }
      }
    },
    // 更改用户权限菜单
    *changeUserMenu({ payload }, { call, put, select }) {
      const { userId, param, method, query, activeTab } = payload;
      const { success, data } = yield call(changeUserMenu, userId, param, method);
      if (success && data === 'success') {
        message.success(
          i18n(method === 'POST' ? 'USERMGR_ADD_MENU_PRIV_SUCCESS' : 'USERMGR_RM_MENU_PRIV_SUCCESS')
        );
        if (activeTab !== '0') {
          yield put({
            type: 'qryDirsByDir',
            payload: {
              userId,
              dirId: 0,
            },
          });
        } else {
          let newQuery = {
            ...query,
          };
          if (JSON.stringify(query) === '{}') {
            // 默认查询第一个portal节点下的menuList
            const { menuTree } = yield select(state => state.userMgr);
            newQuery = {
              ...newQuery,
              ...menuTree[0],
            };
          }
          yield put({
            type: 'qryMenuListByUserParty',
            payload: {
              reload: true,
              userId,
              ...newQuery,
            },
          });
        }
      }
    },
    // 获取目录dirs
    *qryDirsByDir({ payload }, { call, put }) {
      const { dirId } = payload;
      const { success, data } = yield call(qryDirsByDir, dirId);
      if (success) {
        if (data.length > 0) {
          const payloadN = payload;
          // 将dirId置为-1
          payloadN.dirId = -1;
          yield put({
            type: 'qryMenuListByDirId',
            payload: {
              ...payloadN,
            },
          });
        }
      }
    },
    // 获取用户目录dirs下的menuList
    *qryMenuListByDirId({ payload }, { call, put }) {
      const { success, data } = yield call(qryMenuListByDirId, payload);
      if (success) {
        yield put({
          type: 'qryMenuListByUser',
          payload: {
            upList: data,
            ...payload,
          },
        });
      }
    },
    // 下层portlet
    *qryPorletByUser({ payload }, { call, put }) {
      const { success, data } = yield call(qryPorletByUser, payload);
      if (success) {
        yield put({
          type: 'saveDifference',
          payload: {
            downList: data,
            keyProp: 'portletId',
            keepOn: true, // 保留重复字段
            ...payload,
          },
        });
      }
    },
    // 获取某个portal节点下的portlets(上层portlet)
    *qryPorletByPortal({ payload }, { call, put }) {
      const { success, data } = yield call(qryPorletByPortal, payload);
      if (success) {
        const activeData = data.filter(v => v.state === 'A');
        yield put({
          type: 'qryPorletByUser',
          payload: {
            upList: activeData,
            ...payload,
          },
        });
      }
    },
    // 获取用户门户列表
    *queryUserPortalsForPortlet({ payload }, { call, put }) {
      const { userId, portletUserId } = payload;
      const { success, data } = yield call(queryPortalsByUser, userId);
      if (success) {
        const list = formatter(data);
        if (list.length > 0) {
          list.map(v => {
            const item = v;
            delete item.children;
            item.isLeaf = true;
            return item;
          });
          // portlet树节点下无子集
          yield put({
            type: 'save',
            payload: {
              arrayList: list,
              menuTree: list,
            },
          });
          yield put({
            type: 'qryPorletByPortal',
            payload: {
              userId: portletUserId,
              portalId: list[0].portalId,
            },
          });
        } else {
          // 请求下层portlet tableList
          yield put({
            type: 'qryPorletByUser',
            payload: {
              upList: [],
              ...payload,
            },
          });
        }
      }
    },
    // 获取某类型下的portlets(上层portlet)
    *qryPorletByType({ payload }, { call, put }) {
      const { success, data } = yield call(qryPorletByType, payload);
      if (success) {
        yield put({
          type: 'qryPorletByUser',
          payload: {
            upList: data,
            ...payload,
          },
        });
      }
    },
    // 获取porlet所有类型type(当前默认为一个类型=>Default Category)
    *qryType({ payload }, { call, put }) {
      const { success, data } = yield call(qryType, payload);
      if (success) {
        if (data.length > 0) {
          // 查找默认类型下的portlet
          yield put({
            type: 'qryPorletByType',
            payload: {
              ...payload,
              ...data[0],
            },
          });
        } else {
          // 请求下层portlet tableList
          yield put({
            type: 'qryPorletByUser',
            payload: {
              upList: [],
              ...payload,
            },
          });
        }
      }
    },
    // 更改用户权限portlet
    *changeUserPortlet({ payload }, { call, put }) {
      const { userId, portletUserId, param, method, activeTab } = payload;
      const { success, data } = yield call(changeUserMenu, portletUserId, param, method);
      if (success && data === 'success') {
        message.success(
          i18n(method === 'POST' ? 'USERMGR_ADD_PORTLET_PRIV_SUCCESS' : 'USERMGR_RM_PORTLET_PRIV_SUCCESS')
        );
        if (activeTab !== '0') {
          // 根据目录授权
          yield put({
            type: 'qryType',
            payload: {
              userId,
            },
          });
        } else {
          yield put({
            type: 'queryUserPortalsForPortlet',
            payload: {
              portletUserId,
              userId,
            },
          });
        }
      }
    },
    // 获取下层componentsList(downList)
    *queryUsersComponent({ payload }, { call, put }) {
      const { success, data } = yield call(queryUsersComponent, payload);
      if (success) {
        yield put({
          type: 'saveDifference',
          payload: {
            downList: data,
            keyProp: 'componentId',
            keepOn: true, // 保留重复字段
            ...payload,
          },
        });
      }
    },
    // 获取上层componentsList(upList)
    *queryComponentsByMenu({ payload }, { call, put }) {
      const { success, data } = yield call(queryComponentsByMenu, payload);
      if (success) {
        yield put({
          type: 'queryUsersComponent',
          payload: {
            upList: data,
            ...payload,
          },
        });
      }
    },
    // 获取portal树节点下的dirsList
    *queryPortalsDirMenu({ payload }, { call, put }) {
      const { success, data } = yield call(queryPortalsDirMenu, payload);
      if (success) {
        yield put({
          type: 'saveAppendMenuTree',
          payload: {
            sonList: data,
            record: payload,
          },
        });
      }
    },
    // 获取用户门户列表
    *queryUserPortalsForComponent({ payload }, { call, put }) {
      const { userId } = payload;
      const { success, data } = yield call(queryPortalsByUser, userId);
      if (success) {
        const list = formatter(data);
        if (list.length > 0) {
          const query = {
            ...list[0],
          };
          // 请求第一个节点下的子集dirMenus
          yield put({
            type: 'queryPortalsDirMenu',
            payload: {
              arrayList: list,
              ...query,
            },
          });
        }
        // 请求上下层components
        yield put({
          type: 'queryUsersComponent',
          payload: {
            upList: [],
            ...payload,
          },
        });
      }
    },
    // 查询用户是否存在
    *isUser({ payload }, { call }) {
      const { userName } = payload;
      const {
        success,
        data: { list },
      } = yield call(queryAllUsers);
      let returnData = null;
      if (success) {
        returnData = list.filter(item => item.userName === userName);
      }
      return returnData;
    },
    *checkUserCode({ payload }, { call }) {
      const { resolve, userCode } = payload;
      const { success, data } = yield call(checkUserCode, userCode);
      if (success) {
        resolve(data);
      }
    },
    // 更改用户权限component
    *changeRoleComponent({ payload }, { call, put, select }) {
      const { userId, param, method } = payload;
      const { success, data } = yield call(changeUserMenu, userId, param, method);
      if (success && data === 'success') {
        message.success(
          i18n(method === 'POST' ? 'COMPONENT_PRIVILEGE_ADD_SUCCESS' : 'COMPONENT_PRIVILEGE_EDIT_SUCCESS')
        );
        const { upList } = yield select(state => state.userMgr);
        yield put({
          type: 'queryUsersComponent',
          payload: {
            upList,
            ...payload,
          },
        });
      }
    },
    *changeFilterParam({ payload }, { put }) {
      yield put({
        type: 'save',
        payload,
      });
    },
  },

  reducers: {
    clearData(state) {
      // 重置搜索
      return {
        ...state,
        security: {},
        emailRequired: false,
        portalList: [],
        list: [],
        arrayList: [],
        pagination: {},
        upList: [],
        downList: [],
        menuTree: [],
        portalUserMenuList: [],
        defaultMenu: {},
      };
    },
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    saveFavourite(state, { payload }) {
      const { portalUserMenuList = [] } = payload;
      const defaultMenu =
        portalUserMenuList.find(v => v.isDefaultOpen === 'Y') ||
        (portalUserMenuList.length > 0 ? portalUserMenuList[portalUserMenuList.length - 1] : {});
      return {
        ...state,
        ...payload,
        portalUserMenuList,
        defaultMenu,
      };
    },
    resetModalTable(state, { payload }) {
      return {
        ...state,
        ...payload,
        upList: [],
        downList: [],
        menuTree: [],
        arrayList: [],
        portalMenuList: [],
      };
    },
    saveDifference(state, { payload }) {
      const { downList = [], upList = [], keyProp, keepOn = false } = payload;
      let newUpTableList = [...upList];
      if (downList.length > 0) {
        const ids = [];
        // 用户门户与角色门户可重复
        if (keyProp === 'portalId') {
          downList.map(item => {
            if (!item.roleId) {
              ids.push(item[keyProp]);
            }
            return ids;
          });
        } else downList.map(item => ids.push(item[keyProp]));
        if (keepOn) {
          // 保留差集并置disabled
          newUpTableList = upList.map(item => {
            const etem = item;
            const index = ids.findIndex(v => v === etem[keyProp]);
            if (index > -1) etem.disabled = true;
            else etem.disabled = false;
            return etem;
          });
        } else {
          // 差集
          newUpTableList = upList.filter(v => ids.indexOf(v[keyProp]) === -1);
        }
      } else {
        newUpTableList = upList.map(item => Object.assign({}, item, { disabled: false }));
      }
      // 去重
      return {
        ...state,
        ...payload,
        upList: uniqBy(newUpTableList, keyProp),
      };
    },
    saveAppendMenuTree(state, { payload }) {
      const { arrayList } = state;
      const { record, sonList } = payload;
      const { partyId, portalId, arrayList: parentList } = record;
      const pId = partyId !== 0 ? partyId : portalId;
      const pType = partyId !== 0 ? 'partyId' : 'portalId';
      let newSonList = [];
      if (sonList.length > 0) {
        newSonList = formatter(sonList, pId, pType);
      }
      // 首先清空该目录下子目录与菜单
      const array = arrayList.length > 0 ? arrayList : parentList;
      const list = array.concat(newSonList);
      const tree = arrayToTree(list);
      return {
        ...state,
        arrayList: list,
        menuTree: tree,
      };
    },
    changeState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
